import moment from "moment";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router";

const FailedModal = ({ show, setShow, point }) => {
  const history = useHistory();

  return (
    <Modal fullscreen={true} show={show}>
      <Modal.Body className="mt-4 d-flex flex-column align-items-center">
        <div
          style={{ color: "#AE1631", fontSize: "28px" }}
          className="fw-bold my-2"
        >
          {point || 0} points
        </div>
        <div
          style={{ color: "#434343", fontSize: "30px" }}
          className="fw-bold my-4"
        >
          🚨 Failed
        </div>
        <div style={{ color: "#434343", fontSize: "18px" }} className="my-1">
          Sorry, Please try again later.
        </div>
        <div style={{ color: "#7B7B7B", fontSize: "18px" }} className="my-1">
          {moment().format("MMMM Do YYYY, h:mm:ss a")}
        </div>
        <div
          style={{ color: "#3A69DD", fontSize: "20px" }}
          className="fw-bold my-4"
          onClick={() => history.push("/points-info")}
        >
          Transactions
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default FailedModal;
